import { NpvrSearchFormFields } from "../../redux/useSearchForm";

export type MultipleSearchFilter = {
  stringSearchForm: Map<NpvrSearchFormFields, string>
  dateSearchForm: Map<NpvrSearchFormFields, {
    start: string;
    end: string;
}>
}

type MultipleSearchDateType = {
  start: string,
  end: string
}

enum MultipleSearchSourceValues {
  user = 'user',
  series = 'series',
  season = 'season',
} 

enum MultipleSearchStatusValues {
  cancelled = 'cancelled',
  completed = 'completed',
  deleted = 'deleted',
  failed = 'failed',
  ongoing = 'ongoing',
  partial = "partial",
  scheduled = 'scheduled',
} 

export const SOURCE_OPTIONS = [
  {
    label: '',
    value: ''
  },
  {
    label: 'dvr.select_user',
    value: MultipleSearchSourceValues.user
  },
  {
    label: 'dvr.select_series',
    value: MultipleSearchSourceValues.series,
  },
  {
    label: 'dvr.select_season',
    value: MultipleSearchSourceValues.season,
  },
]

export const STATUS_OPTIONS = [
  {
    label: '',
    value: ''
  },
  {
    label: 'dvr.label_status_cancelled',
    value: MultipleSearchStatusValues.cancelled
  },
  {
    label: 'dvr.label_status_completed',
    value: MultipleSearchStatusValues.completed
  },
  {
    label: 'dvr.label_status_deleted',
    value: MultipleSearchStatusValues.deleted
  },
  {
    label: 'dvr.label_status_failed',
    value: MultipleSearchStatusValues.failed
  },
  {
    label: 'dvr.label_status_ongoing',
    value: MultipleSearchStatusValues.ongoing
  },
  {
    label: 'dvr.label_status_partial',
    value: MultipleSearchStatusValues.partial
  },
  {
    label: 'dvr.label_status_scheduled',
    value: MultipleSearchStatusValues.scheduled
  },
  
]